import React from 'react';
import './PrimaryCTA.css';

const PrimaryCTA = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="primary-cta" className="primary-cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">
            See what your salon data has been trying to tell you.
          </h2>

          <div className="cta-buttons">
            <button className="btn btn-primary-large" onClick={scrollToContact}>
              Show Me My Real Numbers
            </button>
            <button className="btn btn-secondary-link" onClick={() => {
              const element = document.getElementById('what-we-deliver');
              element?.scrollIntoView({ behavior: 'smooth' });
            }}>
              What does this look like in practice?
            </button>
          </div>

          <div className="trust-indicators">
            <div className="indicator">
              <span className="indicator-icon">✓</span>
              <span>Works with your existing booking system</span>
            </div>
            <div className="indicator">
              <span className="indicator-icon">✓</span>
              <span>See patterns in your first week</span>
            </div>
            <div className="indicator">
              <span className="indicator-icon">✓</span>
              <span>No technical setup</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrimaryCTA;
